/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment */
import _ from 'lodash';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
import { featureFlagService } from './featureFlagService';

function postToUrl(path: string, params: ltFramework.IDictionary): void {
	const form: HTMLFormElement = document.createElement('form');

	// Move the submit function to another variable
	// so that it doesn't get overwritten.
	// eslint-disable-next-line @typescript-eslint/unbound-method
	form.submitFunction = form.submit;
	form.setAttribute('method', 'POST');
	form.setAttribute('action', path);

	function addField(key: string) {
		const hiddenField: HTMLInputElement = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}

	_.forEach(params, (p) => {
		addField(p);
	});

	document.body.appendChild(form);
	form.submitFunction(); // Call the renamed function.
}

function appendQueryParam(params: ltFramework.IDictionary, href: string): string {
	let url: string = href;

	if (!url) {
		url = window.location.href;
	}
	const keys = params ? Object.keys(params) : [];

	if (params && keys.length) {
		Object.keys(params).forEach((key) => {
			if (url.indexOf('?') > 0) {
				url += '&';
			}
			else {
				url += '?';
			}
			url += key + '=' + params[key];
		});
	}
	return url;
}

function generateGetUrl(obj: ltFramework.IClickEventObj): string {
	let url = obj.partnerOrigHref;

	const params: ltFramework.IDictionary = {};
	if (obj.sso && obj.ssoParamName) {
		params[obj.ssoParamName] = obj.sso;
		url = appendQueryParam(params, url);
	}
	else if (obj.forceSso === 'true') {
		url
			// eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-base-to-string
			= window.ef.urlStore.getInitialData().globalPageDrivers.login
				+ '?resource='
				+ encodeURIComponent(url);
	}
	else if (obj.profileParamName && obj.profileToken) {
		params[obj.profileParamName] = obj.profileToken;
		url = appendQueryParam(params, url);
	}

	return url;
}

function handleClickEvent(el: JQuery, ce?: JQuery.ClickEvent, cme?: JQuery.ContextMenuEvent): void {
	const clickEventObj: ltFramework.IClickEventObj = {
		partnerOrigHref: ce?.data('partner') ?? cme?.data('partner')
	};
	clickEventObj.sso = window.ef.profileStore?.getInitialData().sso;
	clickEventObj.profileToken = window.ef.profileStore?.getInitialData().token;
	clickEventObj.partnerType = ce?.data('partner-type') ?? cme?.data('partner');
	clickEventObj.ssoParamName = ce?.data('param-name') ?? cme?.data('param-name');
	clickEventObj.forceSso = ce?.data('force-sso') ?? cme?.data('force-sso');
	clickEventObj.profileParamName
		= ce?.data('profile-param-name') ?? cme?.data('profile-param-name');
	clickEventObj.newWindow = ce?.data('new-window') ?? cme?.data('new-window');
	clickEventObj.ignorePartnerConfig
		= ce?.data('ignore-partner-config') ?? cme?.data('ignore-partner-config');

	if (clickEventObj.newWindow && !clickEventObj.ignorePartnerConfig) {
		el.attr('target', '_blank');
	}
	// send user to partner servlet
	if (
		clickEventObj.partnerType
		&& clickEventObj.partnerType === 'POST'
		&& !cme
		&& (clickEventObj.sso || clickEventObj.profileToken)
	) {
		if (ce && (ce.preventDefault || typeof ce.preventDefault === 'function')) {
			ce.preventDefault();
		}
		const params: ltFramework.IDictionary = {};

		if (clickEventObj.sso && clickEventObj.ssoParamName) {
			params[clickEventObj.ssoParamName] = clickEventObj.sso;
		}
		else if (clickEventObj.profileParamName && clickEventObj.profileToken) {
			params[clickEventObj.profileParamName] = clickEventObj.profileToken;
		}

		postToUrl(clickEventObj.partnerOrigHref, params);
	}
	else {
		// default to get request
		el.attr('href', generateGetUrl(clickEventObj));
	}
}

export default class UrlService implements ltFramework.IUrlService {
	public getUrlParameter(name: string): null | string {
		name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
		const pattern = '[\\?&]' + name + '=([^&#]*)';
		const regex = new RegExp(pattern);
		const results = regex.exec(window.location.href);

		return results == null ? null : results[1];
	}

	public bindPartnerUrls(): void {
		if (featureFlagService.isEnabled('aemEfDisableProfileStore')) {
			return;
		}
		$('[data-partner]').each((index, item) => {
			// bind click event for partner links
			$(item).bind({
				click(evt) {
					handleClickEvent($(this), evt, undefined);
				},
				contextmenu(evt) {
					handleClickEvent($(this), undefined, evt);
				}
			});
		});
	}

	public isMobileApp(): boolean {
		return window.location.href.includes('.app.html');
	}

	public buildPagePaths(paths: ltFramework.IClubPagePaths): ltFramework.IClubPagePaths {
		if (this.isMobileApp()) {
			Object.keys(paths).forEach((key) => {
				paths[key] = paths[key].replace('.html', '.app.html');
			});
			return paths;
		}
		else {
			return paths;
		}
	}
}

export const urlService = new UrlService();
